import script from "./UserGrowthTrend.vue?vue&type=script&setup=true&lang=js"
export * from "./UserGrowthTrend.vue?vue&type=script&setup=true&lang=js"

import "./UserGrowthTrend.vue?vue&type=style&index=0&id=08de2492&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08de2492"]])

export default __exports__